<template>
  <div>
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <b-card v-if="this.loadpage == false">
      <b-img
        v-for="img in imgList"
        :key="img.length"
        :src="img"
        fluid
        center
        class="pb-1"
      ></b-img>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BImg, BSpinner
} from 'bootstrap-vue'
import { header_token } from '@/views/token'
import { taobaoService_dotnet   } from '@/views/global'
import axios from 'axios'
export default {
  name: 'Taobao2youYuanPayment',

  components: {
    BCard, BImg, BSpinner
   },

  data() {
    return {
      imgList: [],
      loadpage: true,
    };
  },

  created() {
    this.getyuanPaymentPic()
  },

  methods: {
    async getyuanPaymentPic() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const id = await urlParams.get('custExhangeID')
      let response = await axios.get(taobaoService_dotnet  + 'app/Balance/load-yuan-payment-pic?CustExhangeID=' + id,
        { headers: header_token }
      )
      this.imgList = await response.data.photoLink
      this.loadpage = false
    }
  },
};
</script>

<style lang="scss" scoped>

</style>